import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MonthlyCollectionListing } from './Pages'

export const MonthlyCollectionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={MonthlyCollectionListing} />
    </Fragment>
)